import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFlag } from '@calendly/feature-check-react'

import ConfirmationRedirect from 'components/confirmation/redirect'
import { PhoneVerificationFeature } from 'components/phone_verification'
import { completeExternalRedirectFlow } from 'actions/confirmation'
import {
  showExternalRedirectSelector,
  showPhoneVerificationSelector,
} from 'selectors/scheduling'

export const PostBookingRedirect = () => {
  const dispatch = useDispatch()
  const showExternalRedirect = useSelector(showExternalRedirectSelector)
  const showPhoneVerification = useSelector(showPhoneVerificationSelector)
  const phoneVerificationEnabled = useFlag('trust_and_safety_booking_sms_verification', false)

  useEffect(() => {
    if (showPhoneVerification && !phoneVerificationEnabled) {
      dispatch(completeExternalRedirectFlow())
    }
  }, [dispatch, showPhoneVerification, phoneVerificationEnabled])

  if (!showExternalRedirect && !showPhoneVerification) return null

  if (showPhoneVerification) {
    return (
      <PhoneVerificationFeature onComplete={() => dispatch(completeExternalRedirectFlow())} />
    )
  }

  return <ConfirmationRedirect />
}
